import { DataFormProps } from 'types/InputsGridOfBannersProps';

export function verifyIfFormCanSave(
	dataForm: DataFormProps,
	setDataForm: React.Dispatch<React.SetStateAction<DataFormProps>>,
	setCanSaveModuleOnBack: React.Dispatch<React.SetStateAction<boolean>>,
	setMessageErrorForm: React.Dispatch<React.SetStateAction<string>>
) {
	if (dataForm.name === '') {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Preenha o campo "Título"');
		return;
	}

	if (dataForm.height === '' || parseInt(dataForm.height) === 0) {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Preenha o campo "Altura"');
		return;
	}

	if (dataForm.schedule_start !== '' && dataForm.schedule_end === '') {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Se preencheu a data incial, preenha a data final.');
		return;
	}

	if (dataForm.schedule_end !== '' && dataForm.schedule_start === '') {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Se preencheu a data final, preenha a data inicial.');
		return;
	}

	if (new Date(dataForm.schedule_start) > new Date(dataForm.schedule_end)) {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('A data inicial não pode ser depois da data final');
		return;
	}

	if (new Date(dataForm.schedule_end) < new Date(dataForm.schedule_start)) {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('A data final não pode ser antes da data inicial');
		return;
	}

	if (dataForm.typeGridBanners === 0 || dataForm.typeGridBanners === 4) {
		if (dataForm.banners.length > 2) {
			setDataForm((obj) => ({
				...obj,
				banners: [obj?.banners[0], obj?.banners[1]]
			}));
		}

		if (dataForm.banners.length < 2) {
			setCanSaveModuleOnBack(false);
			setMessageErrorForm('Cadastre 2 banners');
			return;
		}
	}

	if (
		dataForm.typeGridBanners === 1 ||
		dataForm.typeGridBanners === 2 ||
		dataForm.typeGridBanners === 3 ||
		dataForm.typeGridBanners === 6
	) {
		if (dataForm.banners.length > 3) {
			setDataForm((obj) => ({
				...obj,
				banners: [obj?.banners[0], obj?.banners[1], obj?.banners[2]]
			}));
		}

		if (dataForm.banners.length < 3) {
			setCanSaveModuleOnBack(false);
			setMessageErrorForm('Cadastre 3 banners');
			return;
		}
	}

	if (dataForm.typeGridBanners === 5) {
		if (dataForm.banners.length > 4) {
			setDataForm((obj) => ({
				...obj,
				banners: [
					obj?.banners[0],
					obj?.banners[1],
					obj?.banners[2],
					obj?.banners[3]
				]
			}));
		}

		if (dataForm.banners.length < 4) {
			setCanSaveModuleOnBack(false);
			setMessageErrorForm('Cadastre 4 banners');
			return;
		}
	}

	setCanSaveModuleOnBack(true);
}
